// import { useEffect, useState } from "react";
// import Cookies from "js-cookie";

// // Reusable Circular Progress Component
// function CircularProgress({ value, max, label, color }) {
//   const radius = 50;
//   const strokeWidth = 8;
//   const circumference = 2 * Math.PI * radius;
//   const progress = (value / max) * circumference;

//   return (
//     <div className="tc">
//       <svg width="120" height="120" className="mb3">
//         <circle
//           cx="60"
//           cy="60"
//           r={radius}
//           stroke="#e5e7eb"
//           strokeWidth={strokeWidth}
//           fill="none"
//         />
//         <circle
//           cx="60"
//           cy="60"
//           r={radius}
//           stroke={color}
//           strokeWidth={strokeWidth}
//           fill="none"
//           strokeDasharray={circumference}
//           strokeDashoffset={circumference - progress}
//           strokeLinecap="round"
//           transform="rotate(-90 60 60)"
//         />
//         <text x="60" y="65" textAnchor="middle" className="f4 fw6 dark-gray">
//           {value}
//         </text>
//       </svg>
//       <div className="f6 gray">{label}</div>
//     </div>
//   );
// }

// export default function RecordsDashboard() {
//   const [records, setRecords] = useState([]);
//   const [clerkRecords, setClerkRecords] = useState([]); // ✅ new state for clerk records
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const adminCookie = Cookies.get("sessionidadmin");
//     if (!adminCookie || adminCookie.length < 1) {
//       setLoading(null);
//       return;
//     }

//     // Fetch all company records
//     const fetchAll = () => {
//       setLoading(true);
//       fetch("https://api.terraweb.africa/getRecords", {
//         method: "post",
//         headers: { "Content-Type": "application/JSON" },
//         body: JSON.stringify({ adminid: adminCookie }),
//       })
//         .then((res) => res.json())
//         .then((data) => {
//           if (data[0]?.id) {
//             setRecords(data);
//           }
//           setLoading(false);
//         })
//         .catch(() => setLoading(null));
//     };

//     // Fetch clerk-specific records
//     const fetchClerk = () => {
//       fetch("https://api.terraweb.africa/filledbyclerkrecords", {
//         method: "post",
//         headers: { "Content-Type": "application/JSON" },
//         body: JSON.stringify({ adminid: adminCookie }),
//       })
//         .then((res) => res.json())
//         .then((data) => {
//           if (data.length > 0) {
//             setClerkRecords(data);
//           }
//         })
//         .catch(() => {});
//     };

//     fetchAll();
//     fetchClerk();
//   }, []);

//   // ✅ All records stats
//   const totalRecords = records.length;
//   const totalWeight = records
//     .reduce((sum, r) => sum + (parseFloat(r.weight) || 0), 0)
//     .toFixed(2);

//   // ✅ Clerk-specific stats
//   const clerkWeight = clerkRecords
//     .reduce((sum, r) => sum + (parseFloat(r.weight) || 0), 0)
//     .toFixed(2);

//   // ✅ Dynamic max values
//   const weightMax = totalWeight > 0 ? totalWeight * 1.2 : 100;
//   const recordsMax = totalRecords > 0 ? totalRecords * 1.2 : 100;
//   const clerkMax = clerkWeight > 0 ? clerkWeight * 1.2 : 100;

//   if (loading) return <div className="pa4 gray">Loading...</div>;

//   return (
//     <div className="pa0">
//       {/* Progress Circles */}
//       <div className="flex flex-wrap justify-center gap4">
//         <CircularProgress
//           value={totalRecords}
//           max={recordsMax}
//           label="Total Records"
//           color="#3b82f6"
//         />
//         <CircularProgress
//           value={totalWeight}
//           max={weightMax}
//           label="Total Weight (kg)"
//           color="#10b981"
//         />
//         <CircularProgress
//           value={clerkWeight}
//           max={clerkMax}
//           label="Your Entries (kg)"
//           color="#f59e0b" // amber for clerk
//         />
//       </div>
//     </div>
//   );
// }


// working dashboard

// import { useEffect, useState } from "react";
// import Cookies from "js-cookie";

// // Reusable Circular Progress Component
// function CircularProgress({ value, max, label, color, isWeight = false }) {
//   const radius = 30;
//   const strokeWidth = 8;
//   const circumference = 2 * Math.PI * radius;
//   const progress = (value / max) * circumference;

//   return (
//     <div className="tc">
//       <svg width="120" height="120" className="mb0">
//         <circle
//           cx="60"
//           cy="60"
//           r={radius}
//           stroke="#e5e7eb"
//           strokeWidth={strokeWidth}
//           fill="none"
//         />
//         <circle
//           cx="60"
//           cy="60"
//           r={radius}
//           stroke={color}
//           strokeWidth={strokeWidth}
//           fill="none"
//           strokeDasharray={circumference}
//           strokeDashoffset={circumference - progress}
//           strokeLinecap="round"
//           transform="rotate(-90 60 60)"
//         />
//         <text x="60" y="65" textAnchor="middle" className="f4 fw6 dark-gray">
//           {isWeight ? value.toFixed(2) : value}
//         </text>
//       </svg>
//       <div className="f6 gray">{label}</div>
//     </div>
//   );
// }

// export default function RecordsDashboard() {
//   const [records, setRecords] = useState([]);
//   const [clerkRecords, setClerkRecords] = useState([]); 
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const adminCookie = Cookies.get("sessionidadmin");
//     if (!adminCookie || adminCookie.length < 1) {
//       setLoading(null);
//       return;
//     }

//     // Fetch all company records
//     const fetchAll = () => {
//       setLoading(true);
//       fetch("https://api.terraweb.africa/getDailyRecords", {
//         method: "post",
//         headers: { "Content-Type": "application/JSON" },
//         body: JSON.stringify({ adminid: adminCookie }),
//       })
//         .then((res) => res.json())
//         .then((data) => {
//           if (data[0]?.id) {
//             setRecords(data);
//           }
//           setLoading(false);
//         })
//         .catch(() => setLoading(null));
//     };

//     // Fetch clerk-specific records
//     const fetchClerk = () => {
//       fetch("https://api.terraweb.africa/filledbyclerkrecords", {
//         method: "post",
//         headers: { "Content-Type": "application/JSON" },
//         body: JSON.stringify({ adminid: adminCookie }),
//       })
//         .then((res) => res.json())
//         .then((data) => {
//           if (data.length > 0) {
//             setClerkRecords(data);
//           }
//         })
//         .catch(() => {});
//     };

//     fetchAll();
//     fetchClerk();
//   }, []);

//   // ✅ All records stats
//   const totalRecords = records.length;
//   const totalWeight = records.reduce(
//     (sum, r) => sum + (parseFloat(r.weight) || 0),
//     0
//   );

//   // ✅ Clerk-specific stats
//   const clerkWeight = clerkRecords.reduce(
//     (sum, r) => sum + (parseFloat(r.weight) || 0),
//     0
//   );

//   // ✅ Dynamic max values
//   const weightMax = totalWeight > 0 ? totalWeight * 1.2 : 100;
//   const recordsMax = totalRecords > 0 ? totalRecords * 1.2 : 100;
//   const clerkMax = clerkWeight > 0 ? clerkWeight * 1.2 : 100;

//   if (loading) return <div className="pa4 gray">Loading...</div>;

//   return (
//     <div className="pa0">
//       {/* Progress Circles */}
//       <div className="flex flex-wrap justify-center gap4">
//         <CircularProgress
//           value={totalRecords}
//           max={recordsMax}
//           label="Total Records"
//           color="#3b82f6"
//         />
//         <CircularProgress
//           value={totalWeight}
//           max={weightMax}
//           label="Total Weight (kg)"
//           color="#10b981"
//           isWeight
//         />
//         <CircularProgress
//           value={clerkWeight}
//           max={clerkMax}
//           label="Your Entries (kg)"
//           color="#f59e0b"
//           isWeight
//         />
//       </div>
//     </div>
//   );
// }


// new with monthly
import { useEffect, useState } from "react";
import Cookies from "js-cookie";

// Reusable Circular Progress Component
function CircularProgress({ value, max, label, color, isWeight = false }) {
  const radius = 30;
  const strokeWidth = 8;
  const circumference = 2 * Math.PI * radius;

  const safeMax = max > 0 ? max : 1;
  const progress = (value / safeMax) * circumference;

  return (
    <div className="tc">
      <svg width="120" height="120">
        <circle
          cx="60"
          cy="60"
          r={radius}
          stroke="#e5e7eb"
          strokeWidth={strokeWidth}
          fill="none"
        />
        <circle
          cx="60"
          cy="60"
          r={radius}
          stroke={color}
          strokeWidth={strokeWidth}
          fill="none"
          strokeDasharray={circumference}
          strokeDashoffset={circumference - progress}
          strokeLinecap="round"
          transform="rotate(-90 60 60)"
        />
        <text x="60" y="65" textAnchor="middle" className="f4 fw6 dark-gray">
          {isWeight ? Number(value).toFixed(2) : value}
        </text>
      </svg>

      <div className="f6 gray">{label}</div>
    </div>
  );
}

export default function RecordsDashboard() {
  const [records, setRecords] = useState([]);
  const [clerkRecords, setClerkRecords] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const adminCookie = Cookies.get("sessionidadmin");
    if (!adminCookie) {
      setLoading(false);
      return;
    }

    // =====================
    // FETCH ALL RECORDS
    // =====================
    const fetchAll = () => {
      fetch("https://api.terraweb.africa/getDailyRecords", {
        method: "POST",
        headers: { "Content-Type": "application/JSON" },
        body: JSON.stringify({ adminid: adminCookie }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (Array.isArray(data)) setRecords(data);
          setLoading(false);
        })
        .catch(() => setLoading(false));
    };

    // =====================
    // FETCH CLERK RECORDS
    // =====================
    const fetchClerk = () => {
      fetch("https://api.terraweb.africa/filledbyclerkrecords", {
        method: "POST",
        headers: { "Content-Type": "application/JSON" },
        body: JSON.stringify({ adminid: adminCookie }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (Array.isArray(data)) setClerkRecords(data);
        })
        .catch(() => {});
    };

    fetchAll();
    fetchClerk();
  }, []);

  // =====================
  // FILTER CURRENT MONTH
  // =====================
  const now = new Date();
  const currentMonth = now.getMonth();
  const currentYear = now.getFullYear();

  const isCurrentMonth = (dateStr) => {
    const d = new Date(dateStr);
    return (
      d.getMonth() === currentMonth &&
      d.getFullYear() === currentYear
    );
  };

  const monthlyRecords = records.filter((r) =>
    isCurrentMonth(r.daterecorded)
  );

  const monthlyClerkRecords = clerkRecords.filter((r) =>
    isCurrentMonth(r.daterecorded)
  );

  // =====================
  // MONTHLY METRICS
  // =====================
  const monthlyTotalRecords = monthlyRecords.length;

  const monthlyWeight = monthlyRecords.reduce(
    (sum, r) => sum + (parseFloat(r.weight) || 0),
    0
  );

  const monthlyEntries = monthlyClerkRecords.length;

  // =====================
  // SAFE MAX VALUES
  // =====================
  const recordsMax =
    monthlyTotalRecords > 0 ? monthlyTotalRecords * 1.2 : 10;

  const weightMax =
    monthlyWeight > 0 ? monthlyWeight * 1.2 : 10;

  const entriesMax =
    monthlyEntries > 0 ? monthlyEntries * 1.2 : 10;

  if (loading) return <div className="pa4 gray">Loading...</div>;

  return (
    <div className="pa0">
      <div className="flex flex-wrap justify-center gap4">

        {/* MONTHLY RECORDS */}
        <CircularProgress
          value={monthlyTotalRecords}
          max={recordsMax}
          label="Total Monthly Records"
          color="#3b82f6"
        />

        {/* MONTHLY WEIGHT */}
        <CircularProgress
          value={monthlyWeight}
          max={weightMax}
          label="Monthly Weight (kg)"
          color="#10b981"
          isWeight
        />

        {/* MONTHLY CLERK ENTRIES */}
        <CircularProgress
          value={monthlyEntries}
          max={entriesMax}
          label="Monthly Entries"
          color="#f59e0b"
        />

      </div>
    </div>
  );
}